module.exports = __webpack_public_path__ + "img/332.19909206.jpg";